<template>
  <div class="sd-layer-tree" :class="{'fade-away-left':!isShow_}"> 
    <div class="layer-tree__panel">
      <div class="panel-header" v-if="!isOnlyView_">
        <button class="button-add header-button" @click="handleOpenConfigLayer" v-hasPermi="['gis:schem:update']">添加图层</button>
        <div style="display: flex">
          <div v-if="alter">
            <el-dropdown v-if="schemName_" @command="handleSaveSchem" v-hasPermi="['gis:schem:update']">
              <el-button class="header-button" type="success" size="small" plain @click="handleSaveSchem(true)">
                保存
                <i class="el-icon-arrow-down el-icon--right" />
              </el-button>
              <el-dropdown-menu slot="dropdown" >
                <el-dropdown-item :command="false" v-hasPermi="['gis:schem:add']">另存为</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-button v-else class="header-button" type="success" size="small" plain @click="handleSaveSchem(false)" v-hasPermi="['gis:schem:update']">保存</el-button>
          </div>
          
          <el-button class="header-button" type="success" size="small" plain @click="handleOpenSchemDialog" v-hasPermi="['gis:schem:list']">选择方案</el-button>
        </div>
      </div>
      <div class="panel-body" ref="layerTreePanel">
        <LayerTree 
          ref="layerTree" 
          class="layer-tree"
          :editorId.sync="editorId_"
          @node-contextmenu="handleTreeContextmenu" 
          @layer-changed="handleLayerChanged" 
          @clear-map="handleClearMap">
          <template v-slot:layerOperate="{data}">
            <i class="el-icon-menu row-image"  v-if="data.dataInfo" title="统计" @click="handleShowStatisticDialog(data)"></i>
            <i class="el-icon-s-order row-image" v-if="data.url && data.photoType==='0'" title="打开属性表" @click="handleOpenLayerAttribute(data)"></i>
            <i class="el-icon-s-promotion row-image"  v-if="data.url" title="缩放到图层范围" @click="handleZoomtoLayer(data)"></i>
            <i class="el-icon-s-tools row-image"  v-if="data.url" title="图层属性" @click="handleOpenLayerSetting(data)" v-hasPermi="['gis:schem:update']"></i>
          </template>
        </LayerTree>
      </div>
      <sd-attribute-panel 
        ref="attributePanel" 
        :visible.sync="isShowAttributePanel_" 
        :projection="projection_" 
        @select-change="handleSelectRow" 
        @zoom-to-selected="handleZoomTo" >
      </sd-attribute-panel>
    </div>

    <schem-dialog ref="schemDialog" @confirm="handleSelectSchem" :alter="alter"></schem-dialog>
    <config-layer-dialog ref='configLayerDialog' @select-change="handleAddRoot2Tree"></config-layer-dialog>
    <add-new-layer-node-dialog ref="addNewLayerNode"></add-new-layer-node-dialog>
    <StatisticsDialog ref="statisticsDialog"></StatisticsDialog>
    <SdAddressSearch2 v-show="switchTabName_==='search'"></SdAddressSearch2>
    <!-- <sd-address-search :offset="isShow_?250:0"></sd-address-search> -->
    
    <slot name="switch">
      <div class="default-switch clickable">
        <div class="switch-item clickable" @click="handleClickSwitchTab('layer')" style="z-index:1" :class="{'select-tab':switchTabName_==='layer'}">
          图层列表
        </div>
        <div class="switch-item clickable" @click="handleClickSwitchTab('search')" style="top:59px" :class="{'select-tab':switchTabName_==='search'}">
          地名搜索
        </div>
      </div>
      
      
    </slot>
  </div>
</template>

<script>
import SdAddressSearch2 from '@/components/OlMap/SdAddressSearch2.vue'
import LayerTree from '@/components/LayerTree'
import ConfigLayerDialog from '@/components/ConfigLayerDialog'
import SchemDialog from '@/components/SchemDialog'
import addNewLayerNodeDialog from '@/components/AddNewLayerNodeDialog'
import StatisticsDialog from '@/components/StatisticsDialog'
import {copyToClipboard} from '@/utils/clipboard.js'
const sharingMapRoute='/sharingMap'
export default {
  name: 'SdLayerTree',
  components: {
    LayerTree,
    ConfigLayerDialog,
    SchemDialog,
    addNewLayerNodeDialog,
    StatisticsDialog,
    SdAddressSearch2
  },
  props: {
    defaultShow:{
      type:Boolean,
      default:false
    },
    mapHandle:{
      type:Object,
      default:null
    },
    alter:{
      type:Boolean,
      default:true
    }
  },
  data() {
    return {
      map_:null,
      projection_:'EPSG:4326',
      isShow_:false,
      layerTreeUid_:-1,
      isShowAttributePanel_:false,
      editorId_:'',
      schemName_:null,
      switchTabName_:'layer',
      isOnlyView_:false
    };
  },
  created(){
    this.isShow_ = this.defaultShow
    this.layerTreeUid_ = new Date().getTime()
  },
  mounted() {
    const firstLoadSchem = this.$route.query.schem
    this.isOnlyView_ = this.$route.path===sharingMapRoute
    if (firstLoadSchem) {
      this.handleSelectSchem(firstLoadSchem)
    }
    if (!this.map_ && this.$parent.map_) {
      this.setMap(this.$parent.map_,this.$parent)
    }
    const hasPermi = this.$auth.hasPermi
    const layerTree = this.$refs.layerTreePanel
    layerTree && layerTree.addEventListener('contextmenu',(event)=>{
      event.preventDefault()
      const menus = [
        {label:'创建分组',onClick:()=>{this.handleAddNewNode() },icon: "el-icon-s-order", hasPermi:hasPermi('gis:schem:update')},
        {label:'清空所有',onClick:()=>{this.handleClearAll() },icon: "el-icon-delete", hasPermi:hasPermi('gis:schem:update')},
        {label:'添加服务图层',onClick:()=>{ this.handleAddNewLayerNode(data,node)},icon: "el-icon-document-add", hasPermi:hasPermi('gis:schem:update')},
        {label:'分享方案',onClick:()=>{this.handleShareSchem() },icon: "el-icon-share",hasPermi:!!this.schemName_ },
      ]
      const items = menus.filter(i=>{return i.hasPermi})
      items && items.length && this.$contextmenu({
        items,
        event, // 鼠标事件信息
        customClass: "map-right-menu", // 自定义菜单 class
        zIndex: 99, // 菜单样式 z-index
        minWidth: 130 // 主菜单最小宽度
      })
    })
    if (this.$auth.hasPermi('gis:schem:update')) {
      
    }
    
  },
  methods: {
    setMap(map){
      this.map_= map
      this.projection_ = map?.getView().getProjection().getCode() || 'EPSG:4326'
      this.initComponents()
    },
    initComponents() {
      const children = this.$children
      children.forEach((child) => {
        if (child.setMap) {
          try {
            child.setMap(this.map_, this)
          } catch (error) {
            console.error(error)
          }
        }
      })
    },
    handleShareSchem(){
      const keys= ['schem','center','zoom','p']
      if (this.schemName_) {
        const fullPath = window.location.href 
        const ar = fullPath.split('?')
        
        const sharing = sharingMapRoute.substring(1,sharingMapRoute.length)
        const first = ar[0]
        const route_path = first.includes(sharingMapRoute)? '?' : `${sharing}?`
        let url =first + route_path
        if (ar[1]) {
          const params = ar[1].split('&')
          params.forEach(p=>{
            const pair = p.split('=')
            const key = pair[0]
            if (!keys.includes(key)) {
              url = url + `${key}=${pair.length>1 ? pair[1] : ''}&`
            }
          })
        }
        url = url + `schem=${this.schemName_}`
        if (this.map_) {
          const view = this.map_.getView()       
          url = url + `&center=${view.getCenter()}&zoom=${view.getZoom()}`
        }
        copyToClipboard(url)
        this.$message({message:'复制地址成功',type:'success'})
      }
    },
    handleClickSwitchTab(name){
      if(this.switchTabName_ === name){
        this.isShow_ = !this.isShow_
      }else{
        this.switchTabName_ = name
      }
    },
    handleTreeContextmenu(event,data,node){
      const hasPermi = this.$auth.hasPermi
      event.preventDefault()
      const menus = data.url?[
        {label:'打开编辑',onClick:()=>{ this.handleShowEditor(data,node)},icon: "el-icon-s-operation", hasPermi:(data.photoType==='0' && node.checked && hasPermi('gis:layer:editor'))},
        {label:'统计',onClick:()=>{ this.handleShowStatisticDialog(data,node)},icon: "el-icon-s-operation", hasPermi:(!!data.dataInfo && hasPermi('gis:layer:statistic'))},
        {label:'重命名',onClick:()=>{ this.handleRenameNode(data,node)},icon: "el-icon-edit", hasPermi:hasPermi('gis:schem:update')},
        {label:'打开属性表',onClick:()=>{ this.handleOpenLayerAttribute(data,node)},icon: "el-icon-s-order",hasPermi:true},
        {label:'缩放到图层',onClick:()=>{ this.handleZoomtoLayer(data,node)},icon: "el-icon-s-promotion",hasPermi:true},
        {label:'图层属性',onClick:()=>{this.handleOpenLayerSetting(data,node)},icon: "el-icon-s-tools", hasPermi:hasPermi('gis:schem:update')},
        {label:'删除图层',onClick:()=>{ this.handleDeleteNode(data,node)},icon: "el-icon-document-delete", hasPermi:hasPermi('gis:schem:update')},
      ]:[
        {label:'重命名',onClick:()=>{ this.handleRenameNode(data,node)},icon: "el-icon-edit" , hasPermi:hasPermi('gis:schem:update')},
        {label:'添加服务图层',onClick:()=>{ this.handleAddNewLayerNode(data,node)},icon: "el-icon-document-add", hasPermi:hasPermi('gis:schem:update')},
        {label:'添加分组',onClick:()=>{ this.handleAddNewNode(data,node)},icon: "el-icon-folder", hasPermi:hasPermi('gis:schem:update')},
        {label:'删除分组',onClick:()=>{ this.handleDeleteNode(data,node)},icon: "el-icon-folder-delete", hasPermi:hasPermi('gis:schem:update')},
      ]

      const items= menus.filter(i=> {return i.hasPermi})

      items && items.length && this.$contextmenu({
        items,
        event, // 鼠标事件信息
        customClass: "map-right-menu", // 自定义菜单 class
        zIndex: 99, // 菜单样式 z-index
        minWidth: 130 // 主菜单最小宽度
      })
    },
    handleShowStatisticDialog(data){
      const ctr = this.$refs.statisticsDialog
      const urlObjs = this.getUrlObjs(data.dataInfo)
      ctr && ctr.open(urlObjs)
    },
    handleZoomtoLayer(data){
      this.mapHandle.zoomToLayerExtent(data)
    },
    handleRenameNode(data){
      this.editorId_ = data.id
    },
    handleAddNewLayerNode(data,node){
      this.$refs.addNewLayerNode && this.$refs.addNewLayerNode.open(data,node)
    },
    handleAddNewNode(data){
      const newNode = {name:'新建分组',id:new Date().getTime(),parentId:data?.id || 0,children:[]}
      if (data) {
        data.children.push(newNode)
      }else{
        this.handleAddRoot2Tree([newNode])
      }
    },
    handleDeleteNode(data,node){
      this.$confirm(`是否删除节点【${node.label}】？`,'提示', {confirmButtonText: '删除',cancelButtonText: '取消', type: '提示',}).then(()=>{
        const parent = node?.parent
        const children = parent.data.children || parent.data
        const index = children.findIndex(item=>item.id === data.id)
        children.splice(index,1)
        if (data.url) {
          this.removeNodeLayer(data)
        }else{
          const nodes = this.getChildUrlNode(data)
          const checkKeys = this.$refs.layerTree?.getCheckedKeys()
          nodes.forEach(item=>{
            if (checkKeys.includes(item.id)) {
              this.removeNodeLayer(item)
            }
          }) 
        }
      })
    },
    handleShowEditor(data){
      this.mapHandle && this.mapHandle.openLayerEditor && this.mapHandle.openLayerEditor(data)
    },
    handleOpenLayerAttribute(data){
      this.isShowAttributePanel_ = true
      this.$refs.popover && this.$refs.popover.doClose()
      if (!data.fieldMapping) {
        data.fieldMapping = this.tryGetJsonObject(data.translate)
        data.fieldValueMapping = {}
      }
      this.$refs.attributePanel && this.$refs.attributePanel.init({
        name:data.layer,
        url:data.url,
        alias:data.name,
        definition:data.definition,
        data
      })
    },
    handleOpenLayerSetting(data){
      this.mapHandle.openLayerSetting(data)
      this.$refs.popover && this.$refs.popover.doClose()
    },
    handleClearAll(){
      const ctr = this.$refs.layerTree
      ctr.clearData()
      this.handleClearMap()
    },
    handleClearMap(){
      this.mapHandle.removeLayer((layer)=>{
        return layer.belongsTo && layer.belongsTo===this.layerTreeUid_
      })
    },
    handleLayerChanged(data,checked){
      //加载图层
      const url = data.url
      if(!url){
        //节点没有图层url，不操作
        return
      }
      if (checked) {
        this.loadNodeLayer(data)
      }else{
       this.removeNodeLayer(data)
      }
    },
    handleOpenConfigLayer(){
      // 打开图层配置树
      const ctr = this.$refs.configLayerDialog
      ctr && ctr.open()
    },
    handleSaveSchem(isNotSaveAs=true){
      const ctr = this.$refs.layerTree
      const schemCtr = this.$refs.schemDialog
      if (ctr && schemCtr) {
        const treeData = ctr.getTreeData()
        const checkedKeys = ctr.getCheckedKeys()
        const halfCheckedKeys = ctr.getHalfCheckedKeys()
        const data = {
          checkedKeys: JSON.stringify(checkedKeys),
          halfCheckedKeys: JSON.stringify(halfCheckedKeys),
          forest: JSON.stringify(treeData)
        }
        schemCtr.selectSchemByName(this.schemName_)
        schemCtr.saveSchem(data,isNotSaveAs)
      }
    },
    handleAddRoot2Tree(treeData){
      const tree = this.$refs.layerTree
      tree && tree.addData(treeData)
    },
    handleSelectSchem(schemName){
      this.handleClearAll()
      const ctr = this.$refs.layerTree
      this.schemName_ = schemName
      ctr && ctr.loadSchemConfig(schemName)
    },
    handleOpenSchemDialog(){
      //选择加载方案
      const ctr = this.$refs.schemDialog
      if (ctr) {
        ctr.open(this.schemName_)
      }
    },
    handleSelectRow(row){
      this.mapHandle && this.mapHandle.hightLightRow(row)
    },
    handleZoomTo(){
      this.mapHandle && this.mapHandle.zoomToHightLight()
    },
    loadNodeLayer(data){
      if (data.layer) {
        this.removeNodeLayer(data)
      }
      const layer= this.mapHandle?this.mapHandle.addLayer(data):null
      if (layer) {
        layer.belongsTo = this.layerTreeUid_
      }
    },
    removeNodeLayer(data){
      this.mapHandle && this.mapHandle.removeLayer(data)
    },
    getChildUrlNode(data){
      let children = []
      if(data.children){
        data.children.forEach(child=>{
          if (child.url) {
            children.push(child)
          }
          const arr = this.getChildUrlNode(child)
          children = children.concat(arr)
        })
      }
      return children
    },
    visible(isShow){
      this.isShow_ = isShow
    },
    tryGetJsonObject(jsonStr){
      let obj = {}
      try{
        obj = JSON.parse(jsonStr)
      }catch(e){
        obj = {}
      }
      return obj
    },
    getUrlObjs(str){
      const urlObjs=[]
      const list = str.split(',')
      list.forEach(item=>{
        const arr = item.split(':')
        if (arr.length===2) {
          urlObjs.push({
            label:arr[0],
            id:arr[1]
          })
        }
      })
      return urlObjs
    },
  },
};
</script>

<style scoped>
.sd-layer-tree{
  position: absolute;
  top: 0;
  left: 0;
  width: 380px;
  height: 100%;
  background: #fff;
  transition: left .3s;
  box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
  user-select: none;
  z-index: 10;
}
.fade-away-left{
  left:-380px;
}
.default-switch{
  position: absolute;
  top:40%;
  right:0px;
 
}
.select-tab{
  z-index: 2;
  opacity:1 !important;
}
.switch-item{
  width: 20px;
  word-break:break-all;       
  word-wrap:break-word;    
  padding:15px 5px;
  background-color: white;
  border-radius: 0 5px 5px 0; 
  position: absolute;
  opacity: 0.5;
  transition: all 0.5s;
  border-left: none;
  box-shadow: 5px 0 5px 0px #7e7d7d87;
}
.layer-tree__panel{
  height: 100%;
  position: relative;
}
.panel-header {
    display: flex;
    justify-content: space-between;
    /* margin-bottom: 10px; */
    padding: 15px;
    height: 35px;
    border-bottom: 1px solid #e8e8e8;
}
.header-button {
  font-size: 14px;
  height: 35px;
  padding: 8px 20px;
  margin-left: 3px;
}
.panel-body{
  height: calc(100% - 100px);
}

.button-add {
    display: inline-block;
    transition: all 0.2s ease-in;
    position: relative;
    overflow: hidden;
    z-index: 1;
    color: #090909;
    border-radius: 0.5em;
    background: #e8e8e8;
    border: 1px solid #e8e8e8;
    box-shadow: 6px 6px 12px #c5c5c5,
        -6px -6px 12px #ffffff;
}

.button-add:active {
    color: #666;
    box-shadow: inset 4px 4px 12px #c5c5c5,
        inset -4px -4px 12px #ffffff;
}

.button-add:before {
    content: "";
    position: absolute;
    left: 50%;
    transform: translateX(-50%) scaleY(1) scaleX(1.25);
    top: 100%;
    width: 140%;
    height: 180%;
    background-color: rgba(0, 0, 0, 0.05);
    border-radius: 50%;
    display: block;
    transition: all 0.5s 0.1s cubic-bezier(0.55, 0, 0.1, 1);
    z-index: -1;
}

.button-add:after {
    content: "";
    position: absolute;
    left: 55%;
    transform: translateX(-50%) scaleY(1) scaleX(1.45);
    top: 180%;
    width: 160%;
    height: 190%;
    background-color: #009087;
    border-radius: 50%;
    display: block;
    transition: all 0.5s 0.1s cubic-bezier(0.55, 0, 0.1, 1);
    z-index: -1;
}

.button-add:hover {
    color: #ffffff;
    border: 1px solid #009087;
}

.button-add:hover:before {
    top: -35%;
    background-color: #009087;
    transform: translateX(-50%) scaleY(1.3) scaleX(0.8);
}

.button-add:hover:after {
    top: -45%;
    background-color: #009087;
    transform: translateX(-50%) scaleY(1.3) scaleX(0.8);
}
.layer-btn-item{
  cursor: pointer;
  padding: 5px 10px;
  margin-top:5px;
  border-bottom: 1px dashed #efefef;
}
.layer-btn-item:hover{
  color: #409eff;
  background-color: #efefef;
}
.row-image{
  color: #9d9d9d;
  margin-left: 3px;
}
</style>